import actions from "~/shared/actions";
import * as server from "~/shared/api/server";

export function startFlyttPkb() {
	return (dispatch) => dispatch(actions.startFlyttPkb());
}

export function selectPkbs(data) {
	return (dispatch) => dispatch(actions.selectPkbs(data));
}

export function confirmPkb(data) {
	return (dispatch) => dispatch(actions.confirmPkb(data));
}

export function createSigningOrder(bundle) {
	return (dispatch) => {
		dispatch(actions.createSigningOrderRequest(bundle));
		return server.createPkbSigningOrder(bundle).then((response) => {
			const result = {
				...response,
				bundleId: bundle.id,
			};
			dispatch(actions.createSigningOrderResponse(result));
			return response;
		});
	};
}

export function createWorkOrders(data) {
	return (dispatch, getState) => {
		const { bundles, consolidate, customer } = getState().flyttPkb;

		const request = {
			...data,
			...customer,
			bundles: bundles.map((b) => ({
				signingId: b.signingId,
				leverandor: b.leverandor,
				avtalenummer: b.avtalenummer,
				consolidate,
			})),
		};

		dispatch(actions.createWorkOrdersRequest(request));
		return server.createPkbWorkOrders(request).then(() => dispatch(actions.createWorkOrdersResponse()));
	};
}
